export default class Dictionary {
    constructor() {
        this.items = {};
    }
    has(key) {
        return Object.prototype.hasOwnProperty.call(this.items, key);
    }
    set(key, val) {
        this.items[key] = val;
    }
    delete(key) {
        if (this.has(key)) {
            delete this.items[key];
            return true;
        }
        return false;
    }
    get(key) {
        return this.has(key) ? this.items[key] : undefined;
    }
    values() {
        let values = [];
        for (let k in this.items) {
            if (this.has(k)) {
                values.push(this.items[k]);
            }
        }
        return values;
    }
}